import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../../components/ui/button';
import CompanyProgressTable from '../../components/admin/CompanyProgressTable';
import CompanyDetailModal from '../../components/admin/CompanyDetailModal';

export default function CompanyProgress() {
  const navigate = useNavigate();
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const handleViewDetails = (company) => {
    setSelectedCompany(company);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedCompany(null);
  };

  return (
    <div className="h-full">
      <CompanyProgressTable onViewDetails={handleViewDetails} />

      {/* Company Detail Modal */}
      <CompanyDetailModal
        open={modalOpen}
        onClose={handleCloseModal}
        company={selectedCompany}
      />
    </div>
  );
}